import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, COMPANY } from "@/data/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b border-zinc-200"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center group" data-testid="navbar-logo">
          <LogoMark className="w-12 h-12 md:w-14 md:h-14" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-[11px] font-medium uppercase tracking-[0.16em] transition-colors ${
                  isActive ? "text-[#BE1E2D]" : "text-black hover:text-[#BE1E2D]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/contact" className="btn-primary" data-testid="navbar-cta-contact">
            Start a Project
          </Link>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          data-testid="navbar-menu-toggle"
        >
          <Menu className="w-6 h-6 text-black" />
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-[60] bg-white flex flex-col" data-testid="mobile-menu">
          <div className="flex items-center justify-between h-20 px-6 border-b border-zinc-200">
            <LogoMark className="w-16 h-16" />
            <button onClick={() => setOpen(false)} aria-label="Close menu" data-testid="mobile-menu-close">
              <X className="w-6 h-6" />
            </button>
          </div>
          <nav className="flex flex-col px-6 py-10 gap-6 flex-1">
            {NAV_LINKS.map((l, i) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display text-4xl tracking-tight ${isActive ? "text-[#BE1E2D]" : "text-black"}`
                }
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              >
                <span className="mono-label mr-4 align-middle">0{i + 1}</span>
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-6 border-t border-zinc-200 space-y-2">
            <div className="mono-label">Abuja · Nigeria</div>
            <div className="text-sm text-zinc-700">{COMPANY.phones[0]}</div>
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary w-full mt-3">
              Start a Project
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export function LogoMark({ className = "w-10 h-10" }) {
  return (
    <img
      src="/mohr-logo.jpg"
      alt="Mohr Engineering Limited"
      className={`${className} object-contain select-none`}
      draggable="false"
    />
  );
}
